import React, { useState } from 'react';
import Header from '../components/ui/Header';
import Footer from '../components/ui/Footer';
import SEO from '../components/SEO';
import FlowViz from '../components/GraphViz'

const allAreas = [
  'Forehead lines',
  'Frown lines',
  'Crow feet',
  'Under eyes',
  'Bags',
  'Dark circles',
  'Cheeks',
  'Nasolabial folds',
  'Marionette lines',
  'Lips',
  'Chin',
  'Jawline',
  'Neck',
];



export const Recs = () => {
  const [highlightedRegionId, setHighlightedRegionId] = useState(null);

  const regionNames = {
    'region-O': 'Orbital',
    'region-F': 'Frontal',
    'region-T': 'Temporal',
    'region-N': 'Nasal',
    'region-L': 'Lip/Perioral',
    'region-Z': 'Zygomatic',
    'region-B': 'Buccal',
    'region-M': 'Mandibular',
  };

  const handleMouseEnter = (id) => {
    setHighlightedRegionId(id);
  };

  const handleMouseLeave = () => {
    setHighlightedRegionId(null);
  };

  const handleClick = (id) => {
    console.log('setHighlightedRegionId', highlightedRegionId, setHighlightedRegionId)
    setHighlightedRegionId(highlightedRegionId === id ? null : id);
  };
  


  return (
    

        <div className="h-[600px] flex flex-col rounded-md bg-[#EDEAF4] items-center overflow-hidden relative">
            
          {/* <div className="w-[274px] h-[325px] bg-[url(/assets/images/face/face.png)] bg-cover bg-white/50 border border-[#A194A5] rounded-md bg-no-repeat top-0 left-0 z-[1]" > */}
            
            <FlowViz/>
            
            

          {/* </div> */}

          

          
        </div>


  );
};

// export default Recommendations;